import React, { useState } from 'react';
import { Search, ChevronDown, Check } from 'lucide-react';
import DateRangeInput from '../dateRangeInput';
import SuggestInput from '../suggestInput';
import styles from './filterPanel.module.scss';

const FilterPanel = ({
    searchValue,
    onSearchChange,
    selectedField,
    onFieldChange,
    filterOptions,
    // field -> the values that field can hold, for the managed lists (genre,
    // profession). Absent for the free-text fields, which then behave exactly
    // as they did.
    suggestionsByField = {}
}) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const selectedOption = filterOptions.find(option => option.value === selectedField) || filterOptions[0];

    const handleFieldSelect = (field) => {
        onFieldChange(field);
        setIsDropdownOpen(false);
    };

    const isDateField = selectedField === 'createdAt';
    const activeSuggestions = suggestionsByField[selectedField];
    

    return (
        <div className={`${styles.filterPanel}`}>
            <div className={styles.searchSection}>
                <div className={styles.dropdownWrapper}>
                    <button
                        className={styles.dropdownButton}
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    >
                        <span className={styles.dropdownText}>{selectedOption.label}</span>
                        <ChevronDown className={styles.chevronIcon} size={16} />
                    </button>
                    
                    {isDropdownOpen && (
                        <div className={styles.dropdownMenu}>
                            {filterOptions.map((option) => (
                                <button
                                    key={option.value}
                                    className={`${styles.dropdownItem} ${selectedField === option.value ? styles.dropdownItemSelected : ''}`}
                                    onClick={() => handleFieldSelect(option.value)}
                                >
                                    <span className={styles.dropdownItemText}>{option.label}</span>
                                    {selectedField === option.value && (
                                        <Check className={styles.checkIcon} size={16} />
                                    )}
                                </button>
                            ))}
                        </div>
                    )}
                </div>

                <div className={styles.searchInputWrapper}>
                    {!isDateField && (
                        <Search className={styles.searchIcon} size={20} />
                    )}
                    {isDateField ? (
                        <DateRangeInput
                            value={searchValue}
                            onChange={onSearchChange}
                            className={styles.dateInput}
                            ariaLabel={selectedOption.label}
                        />
                    ) : activeSuggestions !== undefined ? (
                        <SuggestInput
                            value={searchValue}
                            onChange={onSearchChange}
                            suggestions={activeSuggestions}
                            className={styles.searchInput}
                            placeholder={`Search by ${selectedOption.label.toLowerCase()}...`}
                            ariaLabel={`Search by ${selectedOption.label.toLowerCase()}`}
                        />
                    ) : (
                        <input
                            type="text"
                            placeholder={`Search by ${selectedOption.label.toLowerCase()}...`}
                            value={searchValue}
                            onChange={(e) => onSearchChange(e.target.value)}
                            className={styles.searchInput}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default FilterPanel;
